$(document).ready(function() {
  $('body').addClass('visible')
})
